<template>
  <section>
    <h3 class="sideproject-title">Key Products Delivered</h3>
    <div class="sideproject-column">
      <h3 class="color">Slana | Mexican Fintech (Monetech)</h3>
      <p class="sideproject-description" style="margin-bottom: 7px">
        End-to-end customer-facing lending and BNPL platform delivered under my leadership at Monetech — personal
        loans, merchant BNPL checkout, onboarding verification, and customer account portal for the Mexican market.
      </p>
      <h5>
        <a class="link-no-decoration" href="https://slana.mx/" target="_blank"
          >slana.mx — personal loans<span style="padding-left: 5px">🔗</span></a
        >
      </h5>
      <h5>
        <a class="link-no-decoration" href="https://pay.slana.mx/" target="_blank"
          >pay.slana.mx — BNPL landing<span style="padding-left: 5px">🔗</span></a
        >
      </h5>
      <h5>
        <a class="link-no-decoration" href="https://bnpl.slana.mx/" target="_blank"
          >bnpl.slana.mx — financing onboarding & verification<span style="padding-left: 5px">🔗</span></a
        >
      </h5>
      <h5>
        <a class="link-no-decoration" href="https://my.slana.mx/" target="_blank"
          >my.slana.mx — customer account portal<span style="padding-left: 5px">🔗</span></a
        >
      </h5>
      <div class="stack-row">
        <span class="label-item technology">React</span>
        <span class="label-item technology">TypeScript</span>
        <span class="label-item technology">AWS</span>
        <span class="label-item skill">Fintech</span>
        <span class="label-item skill">Lending</span>
        <span class="label-item skill">BNPL</span>
      </div>
    </div>
    <div class="sideproject-column">
      <h3 class="color">Merchant Account Demo | Unlimit</h3>
      <p class="sideproject-description" style="margin-bottom: 7px">
        Interactive sales demo of Unlimit's Merchant Account platform — built to showcase core product capabilities
        for prospects and delivered with deployment and versioning pipelines for sales and onboarding teams.
      </p>
      <h5>
        <a
          class="link-no-decoration"
          href="https://demo.unlimit.com/ma-new/#/dashboard"
          target="_blank"
          >demo.unlimit.com — merchant account dashboard<span style="padding-left: 5px">🔗</span></a
        >
      </h5>
      <div class="stack-row">
        <span class="label-item technology">Angular</span>
        <span class="label-item technology">TypeScript</span>
        <span class="label-item technology">AWS</span>
        <span class="label-item skill">Fintech</span>
        <span class="label-item skill">Payments</span>
        <span class="label-item skill">CI/CD</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SideProjects"
};
</script>

<style lang="scss">
section {
  padding-top: 40px;
  line-height: 40px;
  padding-inline: 7vw;
}
.sideproject-title {
  font-size: 1.55rem;
  color: #23415d;
  text-align: left;
  text-transform: uppercase;
  border-bottom: 1px solid #23415d;
}

.sideproject-column {
  text-align: left;
  line-height: 25px;
  padding: 10px;
}

.color {
  color: #23415d;
}

.link-no-decoration {
  text-decoration: none;
  color: #23415d;
  font-size: small;
  &:visited {
    text-decoration: none;
  }
}
.sideproject-description {
  line-height: 20px;
  font-size: small;
}

.stack-row {
  display: flex;
  gap: 5px;
  margin-top: 8px;
}

.label-item {
  height: 25px;
  width: fit-content;
  padding: 3px;
  font-size: 11px;
  color: white;
  font-weight: 700;
  padding-inline: 5px;
  border-radius: 3px;
  text-align: center;
  vertical-align: middle;

  display: flex;
  place-content: center;
  place-items: center;
}

.technology {
  background-color: #f6fbff;
  color: black;
}

.skill {
  background-color: #f6fbff;
  color: black;
}
</style>
